<template lang="pug">
  .course-points-shop
    ProductPopup(
      v-if="productForPopup.id"
      :product="productForPopup"
      :balance="balance"
    )
    ConfirmPopup(
      v-if="popupOffer.id"
      :product="popupOffer"
    )

    PromoPopup(
      v-if="shopPromoPopup"
    )
    .course-points-shop__header
      p.course-points-shop__title.main__subtitle
        | Тебе предстоит сложный выбор:
      .course-points-shop__header-controls-wrap
        InfoPopup
        .course-points-shop__header-controls
          UiButton.course-points-shop__header-tag(
            @click="openShopHistory"
            color="light"
            )
            span.course-points-shop__header-tag__highlight История покупок
          p.course-points-shop__header-tag
            | Баллов:
            span.course-points-shop__header-tag__highlight &nbsp;{{balance}}

    .course-points-shop-products
      template(v-if="gettingShop")
        EmptyProduct(
          v-for="i in 6" :key="i"
        )
      template(v-else)
        Product(
          v-for="product in products" :key="product.id"
          :propProduct="product"
          :balance="balance"
        )


</template>

<script>
import { mapState } from 'vuex';
import Product from './Product';
import ProductPopup from './ProductPopup';
import ConfirmPopup from './ConfirmPopup';
import PromoPopup from './PromoPopup';
import EmptyProduct from './EmptyProduct';
import InfoPopup from './InfoPopup';

export default {
  components: {
    Product,
    ProductPopup,
    ConfirmPopup,
    PromoPopup,
    EmptyProduct,
    InfoPopup
  },
  computed: {
    ...mapState('coursePointsShop', {
      balance: s => s.data.balance,
      products: s => s.data.products,
      productForPopup: s => s.data.productForPopup,
      popupOffer: s => s.data.popupOffer,
      shopPromoPopup: s => s.meta.shopPromoPopup,
      gettingShop: s => s.meta.gettingShop
    })
  },
  beforeCreate() {
    this.$store.dispatch('coursePointsShop/getShop', {
      courseId: this.$route.params.courseId
    });
  },
  mounted() {
    this.setHeader();
  },
  methods: {
    openPromo() {
      this.$store.dispatch('coursePointsShop/setMeta', {
        path: 'shopPromoPopup',
        value: true
      });
    },
    openShopHistory() {
      this.$router.replace({
        path: `/courses/course/${this.$route.params.courseId}/points_shop/history`
      });
    },
    setHeader() {
      if (this.courseName) {
        this.$store.dispatch('lms/setMultipleData', [
          { path: 'headerTitle', value: `${this.courseName}` },
          {
            path: 'headerPrevLink',
            value: '/courses/course/' + this.$route.params.courseId
          }
        ]);
      }
    }
  }
};
</script>
